/**
 * Scope method to data.
 *
 * @param {Object} data Dataset.
 * @returns {Function} Getter.
 * @api public
 */
export function get(data = {}) {
  /**
   * Get property from data, fallback to lowercased or uppercased.
   *
   * @param {String} property Name.
   * @param {Boolean} fallback Return property name if no value was found.
   * @returns {Mixed} property value.
   * @api private
   */
  return function propGet(property, fallback) {
    const result = data[property] || data[property.toLowerCase()] || data[property.toUpperCase()];

    return !fallback
      ? result
      : result || property;
  };
}
